<template>
    <div class="personalNew">
        <div class="personalNew-header">
            <h4>个人中心</h4>
            <div class="personalNew-header_content">
                <h4>Hi~ 欢迎加入潘多姆健康管理计划</h4>
                <div style="font-size: 12px;">当前登录手机号:{{userPhone}}</div>
            </div>
        </div>
        <div class="personalNew-content">
            <h4>精选功能</h4>
            <van-cell is-link @click="goPage('rightsPersonNew')">
                <template #icon>
                    <img class="icon" src="@/assets/center12.png" />
                </template>
                <template #title>
                    <span class="custom-title">我的权益</span>
                </template>
            </van-cell>
            <van-cell is-link @click="goPage('fangai')">
                <template #icon>
                    <img class="icon" src="@/assets/record2.png" />
                </template>
                <template #title>
                    <span class="custom-title">防癌问卷</span>
                </template>
            </van-cell>
            <van-cell is-link @click="goPage('appointmentList')">
                <template #icon>
                    <img class="icon" src="@/assets/record2.png" />
                </template>
                <template #title>
                    <span class="custom-title">我的报告</span>
                </template>
            </van-cell>
        </div>
        <div class="logoutDiv">
            <p @click="logout()">退出登录</p>
        </div>
    </div>
</template>
<script>
import { selUserLoginInfo,loginOut } from '@/api';
import { Toast } from 'vant';
export default {
    name: 'personalNew',
    data() {
        return {
            userPhone: null,
            publicType: null,
            pdmJump1Url: '',
            pdmJump2Url: '',
            pdmJump3Url: '',
            pdmJump4Url: ''
        }
    },
    created() {
        this.publicType = localStorage.getItem('publicType');
        this.init();
    },
    methods: {
        goPage(page) {
            if(page == 'appointmentList'){
                if(this.publicType == 1){
                    if(this.pdmJump3Url == null){
                        Toast('您暂时没有潘多姆权益!');
                    }else{
                         window.location.href = this.pdmJump3Url;
                    }
                }else{
                    this.$router.push(page);
                }
            }else if(page == 'fangai'){
                if(this.pdmJump4Url == null){
                    Toast('您暂时没有潘多姆权益!');
                }else{
                    window.location.href = this.pdmJump4Url;
                }
            }else{
                this.$router.push(page);
            }
        },
        async logout(){
            const res = await loginOut({
                publicType : this.publicType
            });
            if (res.code == 200) {
                localStorage.removeItem('token');
                this.goPage('loginNew');
            }
        },
        async init() {
            const res = await selUserLoginInfo({
                publicType : 1
            });
            if (res.code == 200) {
                this.userPhone = res.data.userPhone;
                this.pdmJump1Url = res.data.pdmJump1Url;
                this.pdmJump2Url = res.data.pdmJump2Url;
                this.pdmJump3Url = res.data.pdmJump3Url;
                this.pdmJump4Url = res.data.pdmJump4Url;
            }
        }
    }
}
</script>
<style lang="less" scoped>
.personalNew {
    &-header {
        width: 100%;
        height: 240px;
        background: url(../../assets/center-new-bg.png);
        background-repeat: no-repeat;
        background-size: 100%;
        text-align: center;
        padding: 40px 15px 0;
        text-align: left;
        h4 {
            color: #fff;
            font-size: 18px;
            margin-bottom: 20px;
        }
        &_content {
            border-radius: 8px;
            background-color: #fff;
            padding: 20px 15px;
            h4 {
                color: #000;
                font-size: 17px;
                margin-bottom: 10px;
            }
            div {
                color: #747273;
            }
        }
    }
    &-content {
        width: 90%;
        margin: -20px auto 0;
        padding: 20px 0 5px 15px;
        background-color: #fff;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0px 0px 60px 0px rgba(0,0,0,0.03);
        h4 {
            font-size: 16px;
        }
        .icon {
            width: 20px;
            height: 20px;
            margin-right: 10px;
            transform: translateY(-1px);
        }
        .van-cell {
            font-size: 14px;
            padding: 20px 15px 20px 0;
            align-items: center;
        }
    }
}
.logoutDiv{
    position: fixed;
    width: 100%;
    height: 44px;
    bottom: 50px;
    left: 0;
    padding: 0 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    p{
        width: 100%;
        height: 100%;
        line-height: 44px;
        color: #fff;
        background-color: #FD3D45;
        font-size: 16px;
        border-radius: 22px;
        text-align: center;
    }
}
.icon {
    width: 30px;
    height: 30px;
    margin-right: 10px;
}
</style>